import script from "./FeaturedAdvertisers.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedAdvertisers.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedAdvertisers.vue?vue&type=style&index=0&id=cd93cfd8&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd93cfd8"]])

export default __exports__